import { render } from "./index.vue?vue&type=template&id=5926e78f"
import script from "./simple-dropdown.ts?vue&type=script&lang=js"
export * from "./simple-dropdown.ts?vue&type=script&lang=js"

import "./simple-dropdown.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script